import { MerChantModel } from "../models/merChantModel";

interface IdObject {
  id: string;
  name: string;
}

export const getIdFormSelectBranchData = (words: string[], branchData: MerChantModel[]):string[] => {
  let ids: string[] = [];
  words.forEach((word: string) => {
    let foundObject = branchData.find((branch: MerChantModel) => branch?.nameLa === word || branch?.nameEn === word);

    if (foundObject) {
      ids.push(foundObject.id);
    }
  });
  return ids;
};


export const getIdFormSelectedBranchData = (words: string[], branchData: MerChantModel[]): IdObject[] => {
  let ids: IdObject[] = [];
  
  words.forEach((word: string) => {
      let foundObject = branchData.find((branch: MerChantModel) => branch?.nameLa === word);

      if (foundObject) {
          ids.push({ id: foundObject.id, name: foundObject.nameLa });
      }
  });

  return ids;
};